import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'

import {
  selectDaysOnMarketMean,
  selectInventoryTotal,
  selectCurrentDataPriceMin,
  selectCurrentDataPriceMax,
  selectCurrentDataRepresentsQuartile,
  selectCurrentDataRepresentsMutliFamily,
} from '../../../store/selectors/marketRecord'
import { If, Format, Text } from '../..'
import SectionWrapper from '../SectionWrapper'

import baseStyles from './MarketSpotlight.module.scss'

const typeMessages = defineMessages({
  single: {
    id: 'MarketSpotlight.marketOverview.type.single',
    defaultMessage: 'homes',
  },
  multi: {
    id: 'MarketSpotlight.marketOverview.type.multi',
    defaultMessage: 'condos',
  },
})

const MarketOverview = () => {
  const daysOnMarketMean = Math.round(useSelector(selectDaysOnMarketMean) || 0)
  const availableHomes = Math.round(useSelector(selectInventoryTotal) || 0)
  const priceRangeMin = useSelector(selectCurrentDataPriceMin) || 0
  const priceRangeMax = useSelector(selectCurrentDataPriceMax) || 0
  const forQuartile = useSelector(selectCurrentDataRepresentsQuartile)
  const forMultiFamily = useSelector(selectCurrentDataRepresentsMutliFamily)

  const intl = useIntl()
  const homeTypeCopy = forMultiFamily
    ? intl.formatMessage(typeMessages.multi)
    : intl.formatMessage(typeMessages.single)

  const hasBaseValues = availableHomes > 1 && daysOnMarketMean > 0
  const hasQuartileValues = priceRangeMin > 0 && priceRangeMax > 0

  const show = hasBaseValues && (!forQuartile || hasQuartileValues)

  return (
    <If condition={show}>
      <SectionWrapper
        data-qa='market-overview-section'
        className={baseStyles.section}
      >
        <Text size='l' variant='neutralCool' variantCount='600'>
          <FormattedMessage
            id='MarketSpotlight.marketOverview'
            defaultMessage='There are {availableHomes} in your market {optional} that are selling in around {daysOnMarket}'
            values={{
              availableHomes: (
                <em>
                  {availableHomes} {homeTypeCopy}
                </em>
              ),
              daysOnMarket: (
                <em>
                  {daysOnMarketMean} {daysOnMarketMean > 1 ? 'days' : 'day'}
                </em>
              ),
              optional: Boolean(forQuartile) && (
                <FormattedMessage
                  id='MarketSpotlight.marketOverview.optional'
                  defaultMessage='between {priceRangeMin}-{priceRangeMax}'
                  values={{
                    priceRangeMax: (
                      <Format.Currency value={priceRangeMax} abbreviate />
                    ),
                    priceRangeMin: (
                      <Format.Currency value={priceRangeMin} abbreviate />
                    ),
                  }}
                />
              ),
            }}
          />
        </Text>
      </SectionWrapper>
    </If>
  )
}

export default MarketOverview
